// Redirect access_token storage to memory to avoid persisting tokens in localStorage.
import { setAccessToken, clearAccessToken } from './utils/token';

if (typeof window !== 'undefined' && window.localStorage) {
  const ls = window.localStorage;
  const original = {
    getItem: ls.getItem.bind(ls),
    setItem: ls.setItem.bind(ls),
    removeItem: ls.removeItem.bind(ls),
  };
  let inMemoryToken = null;

  ls.setItem = (key, value) => {
    if (key === 'access_token') {
      inMemoryToken = value || null;
      setAccessToken(inMemoryToken);
      return;
    }
    return original.setItem(key, value);
  };

  ls.getItem = (key) => {
    if (key === 'access_token') {
      return inMemoryToken;
    }
    return original.getItem(key);
  };

  ls.removeItem = (key) => {
    if (key === 'access_token') {
      inMemoryToken = null;
      clearAccessToken();
      return;
    }
    return original.removeItem(key);
  };
}
